import { render, staticRenderFns } from "./bidding-confirm.vue?vue&type=template&id=83cc160c&scoped=true"
import script from "./bidding-confirm.vue?vue&type=script&lang=js"
export * from "./bidding-confirm.vue?vue&type=script&lang=js"
import style0 from "./bidding-confirm.vue?vue&type=style&index=0&id=83cc160c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83cc160c",
  null
  
)

export default component.exports